export function initScrollAnimation(): void {
    window.addEventListener('scroll', () => {
        const scrollRatio = window.pageYOffset / (document.body.offsetHeight - window.innerHeight);
        document.body.style.setProperty('--scroll', String(scrollRatio));
    }, { passive: true });
}
